<template>
  <li class="scheduler_user"
      :style="{'min-height': 40 * rows + 'px'}">
    <div v-for="event in correctEvents"
         :key="event.obj.id"
         class="day-cal__event day-cal__event__lesson"
         :content="event.obj.v_user_names"
         v-tippy="{
                    arrow: true,
                    zIndex: 123123123123,
                    onShow: () => event.obj.v_has_teachers
                  }"
         :style="[
         {'top': event.row * 26 + 'px'},
         {'left': event.left + 'px'},
         {'right': event.right + 'px'},
         {'height': '25px'}]"
         :ref="calEvent"
         :aria-label="event.othersOnLesson">
      <div class="day-cal__event__content">
        <div class="day-cal__event__content__title">
          <span class="nowrap day-cal__event__content__title__title">{{ event.obj.title }}</span>
          <span class="nowrap day-cal__event__content__title__grade" v-if="event.obj.v_groups.length > 0">{{ event.obj.v_group_names }}</span>
        </div>
        <div class="day-cal__event__bg" :style="{backgroundColor: event.obj.color ? event.obj.color : '#ccc'}"></div>
        <div class="day-cal__event__sider" :style="{backgroundColor: event.obj.color ? event.obj.color : '#ccc'}"></div>
      </div>
    </div>
    <div class="day-cal__event work_hours"
         v-for="presence in userPresenceForPlacing"
         :key="presence.obj.id"
         :style="[
         {'left': presence.left + 'px'},
         {'right': presence.right + 'px'}
         ]">
    </div>
  </li>
</template>

<script>
import Moment from 'moment'
import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)

export default {
  props: {
    user: {}
  },
  data () {
    return {
      slotWidth: 40,
      slotHeight: 40,
      rows: 1,
      firstEvent: true,
      correctEvents: [],
      subScoreMeta: [],
      oldSubScoreMeta: []
    }
  },
  computed: {
    userLessons () {
      return this.user.dayEvents
    },
    userPresence () {
      return this.user.dayPresence
    },
    userPresenceForPlacing () {
      return this.userPresence.map(event => {
        return {
          'left': this.eventTop(event),
          'right': this.eventRight(event),
          'obj': event
        }
      })
    },
    sortedEvents () {
      let arr = this.userLessons
      return arr.sort((a, b) => {
        return moment(a.start).unix() - moment(b.start).unix()
      })
    }
  },
  watch: {
    sortedEvents () {
      this.rows = 1
      this.$emit('rows', {'rows': this.rows})
      this.correctEvents.splice(0, this.correctEvents.length)
      this.setWidthAndLeft()
    }
  },
  methods: {
    isActiveEvent (event) {
      return this.activeEvent && event.obj.id === this.activeEvent.obj.id && this.activeUser && this.user.id === this.activeUser.id
    },
    eventRight (event) {
      const time = moment.duration({
        minutes: moment(event.end).format('mm'),
        hours: moment(event.end).format('HH')
      }).asMinutes()
      const endOfDay = moment.duration({
        hours: 24,
        minutes: 0
      }).asMinutes()
      return ((this.slotWidth * 2) / 60) * (endOfDay - time)
    },
    eventTop (event) {
      let calStartTime = moment(event.start).set({
        'hour': 0,
        'minutes': 0
      })
      let eventStartTime = moment(event.start)
      let duration = moment(eventStartTime).diff(calStartTime)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    eventHeight (event) {
      let duration = moment(event.end).diff(event.start)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    eventBottom (event) {
      let calStartTime = moment(event.end).set({
        'hour': 0,
        'minutes': 0
      })
      let eventEndTime = moment(event.end)
      let duration = moment(eventEndTime).diff(calStartTime)
      return ((this.slotHeight * 2) / 60) * moment.duration(duration).asMinutes()
    },
    // Check if two events collide
    collidesWith (a, b) {
      return a.bottom > b.top && a.top < b.bottom
    },
    packEvents (columns) {
      let n = columns.length
      for (let i = 0; i < n; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev = col[j]
          let colSpan = this.expandEvent(ev, i, columns)
          col[j].row = i
          if ((i + 1) > this.rows) {
            this.rows = i + 1
          }
          this.$emit('rows', {'rows': this.rows})
          col[j].colspan = colSpan / n
          this.correctEvents.push(col[j])
          // Scroll cal to first event
          if (this.firstEvent) {
            this.$emit('lessonsUpdate', this.correctEvents[0])
          }
          this.firstEvent = false
        }
      }
    },
    expandEvent (ev, iColumn, columns) {
      let colSpan = 1
      for (let i = iColumn + 1; i < columns.length; i++) {
        let col = columns[i]
        for (let j = 0; j < col.length; j++) {
          let ev1 = col[j]
          if (this.collidesWith(ev, ev1)) {
            return colSpan
          }
        }
        colSpan++
      }
      return colSpan
    },
    setWidthAndLeft () {
      let columns = []
      let lastEventEnding = null
      let events = this.sortedEvents.map(elem => {
        const top = this.eventTop(elem)
        const height = this.eventHeight(elem)
        const bottom = this.eventBottom(elem)
        const right = this.eventRight(elem)
        return {
          'obj': elem,
          'top': top,
          'left': top,
          'right': right,
          'height': height,
          'bottom': bottom,
          'subs': [],
          'othersOnLesson': elem.teacher,
          'klassesOnLesson': elem.group
        }
      })
      events.sort(function (e1, e2) {
        if (e1.top < e2.top) return -1
        if (e1.top > e2.top) return 1
        if (e1.bottom < e2.bottom) return -1
        if (e1.bottom > e2.bottom) return 1
        return 0
      })
      for (let i = 0; i < events.length; i++) {
        let e = events[i]
        if (lastEventEnding !== null && e.top >= lastEventEnding) {
          this.packEvents(columns)
          columns = []
          lastEventEnding = null
        }
        let placed = false
        for (let j = 0; j < columns.length; j++) {
          let col = columns[j]
          if (!this.collidesWith(col[col.length - 1], e)) {
            col.push(e)
            placed = true
            break
          }
        }
        if (!placed) {
          columns.push([e])
        }
        if (lastEventEnding === null || e.bottom > lastEventEnding) {
          lastEventEnding = e.bottom
        }
      }
      if (columns.length > 0) {
        this.packEvents(columns)
      }
    }
  },
  mounted () {
    this.rows = 1
    this.$emit('rows', {'rows': this.rows})
    this.setWidthAndLeft()
  }
}
</script>

<style scoped>
.scheduler_user {
  position: relative;
  height: 20px;
}

.day-cal__event {
  cursor: default;
  color: white;
  display: block;
  font-size: .85em;
  line-height: 1.3;
  font-weight: 400;
  position: absolute;
  top: 20px;
  left: 0%;
  right: 0%;
  border-right: 1px solid transparent !important;
  border-top: 1px solid transparent !important;
}

.day-cal__event.isActiveEvent {
  z-index: 100;
  box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
}

.day-cal__event__content {
  color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 3px 2px 3px 8px;
  left: 0;
  top: 0;
  font-size: 1rem;
  z-index: 1;
}

.day-cal__event__bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  opacity: 0.8;
}

.day-cal__event__lesson {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.day-cal__event__sider {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  z-index: 2;
}

.day-cal__event__content__title {
  display: flex;
  position: absolute;
  top: 1px;
  bottom: 1px;
  left: 6px;
  flex-direction: column;
  width: calc(100% - 8px);
  z-index: 2;
  font-size: 10px !important;
  overflow: hidden;
}

.day-cal__event__content__title__title {
  font-weight: bold;
}

.day-cal__event__content__title__grade {
  font-size: 8px;
}

.nowrap {
  white-space: nowrap;
}

.user_absence {
  position: absolute;
  top: 0 !important;
  height: calc(100% - 2px);
  border-top: 12px solid rgb(86, 68, 55);
  background: rgb(86, 68, 55, 0.4) !important;
}

.user_absence__delete {
  position: absolute;
  width: 100px;
  top: 0;
  left: calc(100% + 5px);
  background-color: white;
  border: 1px solid #cccccc;
  z-index: 10000;
}

.user_absence__text {
  position: absolute;
  z-index: 10;
  top: -17px;
  left: 2px;
  height: 16px;
  overflow: hidden;
  color: #ffffff;
  font-size: 9px;
  text-transform: uppercase;
}

.work_hours {
  top: 0 !important;
  height: calc(100% - 5px) !important;
  bottom: 0 !important;
  background: rgba(153, 197, 244, .4) !important;
}

.item-is-headline {
  background-color: #3e4450 !important;
  color: #fff !important;
  font-weight: 700;
}

.day-cal__event__subs {
  position: absolute;
  top: 0px;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.day-cal__event__subs__img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 2px;
}

.day-cal__event__other {
  background-color: #3e4450;
  border-radius: 50%;
  font-size: 10px;
  padding: 1px;
  text-align: center;
  overflow: hidden;
  height: 15px;
  width: 15px;
}

@keyframes bigPulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.15, 1.15, 1.15);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.bigPulseTwo {
  animation-name: bigPulse;
}


</style>



// WEBPACK FOOTER //
// DSchedulerItem.vue?c4aca134